var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v(_vm._s(_vm.$t('hello')))]),_c('h1',[_vm._v("This is an about page, the res is:")]),_c('pre',[_vm._v(_vm._s(this.res))])])}
var staticRenderFns = []

export { render, staticRenderFns }